import { render } from "./EntityList.vue?vue&type=template&id=6c650b20&scoped=true"
import script from "./EntityList.vue?vue&type=script&lang=js"
export * from "./EntityList.vue?vue&type=script&lang=js"

import "./EntityList.vue?vue&type=style&index=0&id=6c650b20&scoped=true&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c650b20"]])

export default __exports__